import React from 'react';
import { Form, Button } from 'react-bootstrap';
import './Feedback.scss';

function Feedback({ condition, contactTeam, type = "warning", messages = [] }) {
  return (
    <>
      <Form.Control.Feedback type={type} className="trigger-feedback-invalid col p-0">
        <div className={`feedback-container-${condition ? "after" : "before"}`}>
          <div className="d-flex align-items-center flex-wrap justify-content-between">
            <div className="feedback-text-stack col-9">
              {messages?.map(m => m)}
              {contactTeam && <div className="mt-1 p-0">Contact the team to learn more.</div>}
            </div>
            {contactTeam && <Button className="feedback-button col-3" variant="primary" data-intercom-target={"open-chat-button"}>Open Chat</Button>}
          </div>
        </div>
      </Form.Control.Feedback>
    </>
  )
}

export default Feedback;
